import { render } from "./JianChaView.vue?vue&type=template&id=01531ead&scoped=true&ts=true"
import script from "./JianChaView.vue?vue&type=script&lang=ts"
export * from "./JianChaView.vue?vue&type=script&lang=ts"

import "./JianChaView.vue?vue&type=style&index=0&id=01531ead&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01531ead"]])

export default __exports__